import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'nb';
    document.title = 'MATTEKLAR™ – Ferdige matematikkøkter for 1.–10. trinn';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3mk868ye44bdj">
      <div lang="nb" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3mj6k9yvk64h1">
        <CountdownBar data-id="element-2" data-mp="3recctgjguhe3" />
        <main data-id="element-3" data-mp="5otf64sd496">
          <Hero data-id="element-4" data-mp="6htjo98ovic" />
          <StatsBar data-id="element-5" data-mp="4wyzymxdckh" />
          <Difference data-id="element-6" data-mp="56ntiw8hdol" />
          <Recognize data-id="element-7" data-mp="7stfczkdj46" />
          <WhatsInside data-id="element-8" data-mp="2zllf11m4wkmq" />
          <InsidePages data-id="element-9" data-mp="2zm4xcjfp5b1a" />
          <Bonuses data-id="element-10" data-mp="2zmwj72jhrued" />
          <HowItWorks data-id="element-11" data-mp="2zng32ospcsv1" />
          <Audience data-id="element-12" data-mp="33mf6g4yschkd" />
          <Offer data-id="element-13" data-mp="33nq73vwxp979" />
          <Guarantee data-id="element-14" data-mp="33n6yx6x35z6f" />
          <Testimonials data-id="element-15" data-mp="33orki71fa7s5" />
          <Faq data-id="element-16" data-mp="38m1gk5jbhhoy" />
          <FinalCta data-id="element-17" data-mp="38li95irambp6" />
        </main>
        <Footer data-id="element-18" data-mp="38k6wsujs7vmg" />
      </div>
    </MotionConfig>;
}